import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
	<section id="hero" className="hero">
      <h2>Bienvenue chez EO Arts</h2>
        <p>
			Spécialiste de l’animation événementielle autour des jeux de société modernes, que ce soit en entreprise, en boutique, lors de salons ou de festivals, je crée des expériences ludiques sur-mesure pour faire de votre événement un succès.
        </p>
    </section>
  );
};

export default Hero;